import {
  EditableInsuranceDetailsCard,
  InsuranceDetailsCard,
  ManualInsuranceDetailsCard,
} from "Components/InsuranceDetailsCard";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

import { InsuranceProduct } from "Store/interfaces/products/checkout";
import React from "react";

export const mapEditableInsuranceCards = (
  products: InsuranceProduct[],
  handleRemoveProducts: (products: InsuranceProduct[]) => void,
): React.ReactElement[] => {
  return products.map((product) => {
    if (product.name === INSURANCE_NAME_VALUE.MANUAL) {
      return (
        <ManualInsuranceDetailsCard
          product={product}
          key={product.productId}
          showDetails
          displayIssueDate
        />
      );
    }

    if (product.name === INSURANCE_NAME_VALUE.NEW_CHILD) {
      const childHealthProduct = products.find(
        (childHealthProduct) =>
          childHealthProduct.name === INSURANCE_NAME_VALUE.CHILD_HEALTH &&
          childHealthProduct.relatedChildProductId === product.productId,
      );
      return (
        <EditableInsuranceDetailsCard
          onRemoveProduct={handleRemoveProducts}
          product={product}
          additionalProduct={childHealthProduct}
          key={product.productId}
        />
      );
    }

    return (
      <EditableInsuranceDetailsCard
        onRemoveProduct={handleRemoveProducts}
        product={product}
        key={product.productId}
      />
    );
  });
};

export const mapInsuranceCards = (
  products: InsuranceProduct[],
  showDetails = false,
  displayIssueDate?: boolean,
): React.ReactElement[] => {
  return products.map((product) => {
    if (product.name === INSURANCE_NAME_VALUE.MANUAL) {
      return (
        <ManualInsuranceDetailsCard
          product={product}
          key={product.productId}
          showDetails={showDetails}
          displayIssueDate={displayIssueDate}
        />
      );
    }

    return (
      <InsuranceDetailsCard
        product={product}
        key={product.productId}
        showDetails={showDetails}
        displayIssueDate={displayIssueDate}
      />
    );
  });
};
